import { Modal } from '@aloft/toolkit-sui';

type ColumnSettingsModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

export const ColumnSettingsModal = ({ isOpen, onClose }: ColumnSettingsModalProps) => (
  <Modal
    size="sm"
    isOpen={isOpen}
    onClose={onClose}
    closeOnEsc
    title="Column Settings"
    primaryAction={{
      text: 'Close',
      onClick: onClose,
    }}
  >
    {/* Placeholder — functionality to be implemented in a future ticket */}
  </Modal>
);
